module.exports = __webpack_public_path__ + "static/media/vip-hour-tile-1star.7eee4918.png";